import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/components/Index';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      beforeEnter() {
        window.location = 'https://signable.co.uk';
      },
    },
    {
      path: '/preview/:previewURL',
      // alias: '/:envelopeFingerprint/:signatureFingerprint',
      name: 'IndexPreview',
      component: Index,
    },
    {
      path: '/:envelopeFingerprint/:signatureFingerprint',
      name: 'Index',
      component: Index,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js